document.addEventListener("DOMContentLoaded", () => {
  try {
    const scrollContainer = document.querySelector(
      ".collection-split .collection-split__products .float-grid"
    );
    const scrollbar = document.querySelector(".custom-scrollbar");
    if (scrollContainer && scrollbar) {
      const style = window.getComputedStyle(scrollContainer);
      const paddingLeft = parseInt(style.paddingLeft) || 0;
      const updateScrollbar = () => {
        const scrollWidth =
          scrollContainer.scrollWidth - paddingLeft - paddingLeft;
        const clientWidth =
          scrollContainer.clientWidth - paddingLeft - paddingLeft;
        const scrollLeft = scrollContainer.scrollLeft;

        const trackWidth = (clientWidth / scrollWidth) * clientWidth;
        const position = (scrollLeft / scrollWidth) * clientWidth;

        if (scrollWidth > clientWidth) {
          scrollbar.style.setProperty("--track-width", `${trackWidth}px`);
          scrollbar.style.setProperty("--position", `${position}px`);
          scrollbar.style.display = "block";
        } else {
          scrollbar.style.display = "none";
          scrollbar.style.setProperty("--track-width", `0px`);
        }
      };

      updateScrollbar();
      scrollContainer.addEventListener("scroll", updateScrollbar, { passive: true });
      window.addEventListener("resize", updateScrollbar, { passive: true });
    }

    // set pc scroll
    const grid = document.querySelector(".collection-split__grid");
    const container = document.querySelector(
      ".collection-split__products .float-grid.grid--2"
    );
    const items = document.querySelectorAll(".collection-split__product");

    if (grid && container) {
      const gridHeight = grid.offsetHeight;

      container.style.maxHeight = `${gridHeight}px`;

      items.forEach((item) => {
        item.classList.remove("pc-hidden");
        item.style.display = "";
      });
    }
  } catch (e) {
    console.log(e);
  }
  // custom handle variant change
  window.customHandleVariantChange = function (variantData) {
    console.log(variantData, 'variantData')
    if (variantData) {
      toggleMedia(variantData.id);

      // Update inventory status
      // updateInventoryStatus(variantData);

      // quick-buy-modal update sku  add to cart text
      updateQuickBuyModalButtonText(variantData);

      setSizeDetail(variantData.option2)
    }

  }

  // quick-buy-modal update sku  add to cart text
  function updateQuickBuyModalButtonText(variantData) {
    const variantId = variantData.id;
    if (!variantId) return;
    const buttonEle = document.querySelector('.quick-buy-modal[data-type="updateSku"] .add-to-cart');
    const quickBuyVariantId = document.querySelector('.quick-buy-modal[data-type="updateSku"]')?.getAttribute('data-variant');
    if (buttonEle) {
      if (buttonEle.innerHTML === "Add to cart") {
        buttonEle.innerHTML = 'UPDATE';

        buttonEle.disabled = variantId === Number(quickBuyVariantId);
      }

    }
  }

  // Update inventory status based on variant id
  function updateInventoryStatus(variantData) {
    const variantId = variantData.id;
    if (!variantId) return;
    // 区分快速弹窗, 不影响详情页的
    const modal = document.querySelector('.quick-buy-modal[open]');
    const parentNode = modal ? modal : document;

    // Hide all status messages
    const allStatusMessages = parentNode.querySelectorAll('.product-block--inventory .inventory-status-p');
    allStatusMessages.forEach(msg => msg.style.display = 'none');
    // Show the status messages for the selected variant
    const variantMessage = parentNode.querySelector(`.product-block--inventory p[data-variant-id="${variantId}"]`);
    if (variantMessage) {
      variantMessage.style.display = 'block';
    }
  }

  // product variant image (optimized: avoids heavy JSON.parse)
  function toggleMedia(variantId) {
    if (!variantId) return;
    // 区分快速弹窗不执行, 不影响详情页的
    const modal = document.querySelector('.quick-buy-modal[open]');
    if (modal) return;
    const variantEl = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!variantEl) return;
    const mediaIds = variantEl.getAttribute('data-media-ids') || '';
    const mediaNodes = document.querySelectorAll('.product-media-collage__item, .mobile-only .slider__item');
    if (!mediaNodes.length) return;

    if (!mediaIds) {
      mediaNodes.forEach(function (i) { i.removeAttribute('hidden'); });
      return;
    }

    const mediaIdList = mediaIds.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    let hasIntersection = false;
    for (let j = 0; j < mediaNodes.length; j++) {
      const mId = mediaNodes[j].getAttribute('data-media-id');
      if (mId && mediaIdList.indexOf(mId) !== -1) {
        hasIntersection = true;
        break;
      }
    }

    if (!hasIntersection) {
      mediaNodes.forEach(function (i) { i.removeAttribute('hidden'); });
      return;
    }

    mediaNodes.forEach(function (i) {
      const mediaId = i.getAttribute('data-media-id');
      if (mediaId && mediaIdList.indexOf(mediaId) !== -1) {
        i.removeAttribute('hidden');
      } else {
        i.setAttribute('hidden', '');
      }
    });
  }
  // product page init
  if (document.querySelector('#product-data')) {
    const firstVariantId = document.querySelector('#product-data').getAttribute('data-first-variant-id');
    // page load init
    toggleMedia(firstVariantId);
  }

  // Auto-select first in-stock size when the variant from the URL is out of stock
  (function autoSelectFirstAvailableVariant() {
    // Only run on product pages that have a variant-picker
    const variantPickerEl = document.querySelector('variant-picker');
    if (!variantPickerEl) return;

    // The variant-picker sets a 'loaded' attribute after initialization.
    // We wait for it before reading the selected state.
    function runAutoSelect() {
      // Parse all variants from the embedded JSON
      const dataEl = variantPickerEl.querySelector('[type="application/json"]');
      if (!dataEl) return;
      const data = JSON.parse(dataEl.textContent);
      const allVariants = data.variants;
      if (!allVariants || !allVariants.length) return;

      // Determine the currently selected variant id from the URL (?variant=xxx)
      const searchParams = new URLSearchParams(window.location.search);
      const urlVariantId = parseInt(searchParams.get('variant'), 10);
      if (!urlVariantId) return; // No variant param – Shopify already handles default selection

      // Find the variant object for the URL param
      const selectedVariant = allVariants.find(v => v.id === urlVariantId);
      if (!selectedVariant) return;

      // If the URL variant is available, no action needed
      if (selectedVariant.available) return;

      // Find the first in-stock variant that shares the same color (option1)
      const sameColorInStock = allVariants.find(
        v => v.option1 === selectedVariant.option1 && v.available
      );
      if (!sameColorInStock) return;

      // Locate and click the radio input for that variant's size (option2).
      // The radio inputs inside variant-picker have value equal to the option value.
      // We target the size selector (option2) specifically.
      const sizeSelector = variantPickerEl.querySelector(
        '.option-selector[data-option="Size"], .option-selector[data-option="size"]'
      );
      if (!sizeSelector) return;

      const targetInput = Array.from(sizeSelector.querySelectorAll('input.js-option')).find(
        input => input.value === sameColorInStock.option2
      );
      if (!targetInput || targetInput.checked) return;

      // Check the input and dispatch a change event to trigger all picker updates
      targetInput.checked = true;
      targetInput.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false }));
    }

    // Wait for the variant-picker to finish initializing
    if (variantPickerEl.hasAttribute('loaded')) {
      runAutoSelect();
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        if (variantPickerEl.hasAttribute('loaded')) {
          obs.disconnect();
          runAutoSelect();
        }
      });
      observer.observe(variantPickerEl, { attributes: true, attributeFilter: ['loaded'] });
    }
  })();

  // product fit last tips
  function updateLastFilledSegment() {
    // Remove triangle class from all segments first
    document.querySelectorAll('.segment-bar__segment--filled').forEach(segment => {
      segment.classList.remove('segment-bar__segment--filled-last');
    });

    // Get all filled segments and add the class to the last one
    const filledSegments = document.querySelectorAll('.segment-bar__segment--filled');
    if (filledSegments.length > 0) {
      filledSegments[filledSegments.length - 1].classList.add('segment-bar__segment--filled-last');
    }
  }

  updateLastFilledSegment();

  
// Lintico Kiwi integration: native selectors, both table orientations, late loading.
var linticoSizeChartContent;
function getSizeSelector() {
  const root = document.querySelector('.detail.product-column-right');
  if (!root) return null;
  const legacy = root.querySelector('[option-target="option2"]');
  if (legacy) return legacy;
  return Array.from(root.querySelectorAll('.option-selector[data-option]')).find(
    node => node.getAttribute('data-option').trim().toLowerCase() === 'size'
  ) || null;
}
function readSizeMeasurements(rows, size) {
  const normalize = value => String(value || '').trim().toLowerCase();
  if (!rows.length || !normalize(size)) return [];
  const header = rows[0];
  const sizeRow = rows.slice(1).find(row => normalize(row[0]) === normalize(size));
  if (sizeRow) {
    return header.slice(1).map((label, index) => [label, sizeRow[index + 1] || ''])
      .filter(([label, value]) => label && value);
  }
  const column = header.findIndex((value, index) => index > 0 && normalize(value) === normalize(size));
  if (column < 0) return [];
  return rows.slice(1).map(row => [row[0], row[column] || ''])
    .filter(([label, value]) => label && value);
}
function getSizeChartTable() {
  // Kiwi moves the contents out of the hidden chart wrapper while its modal is open.
  const modalTable = document.querySelector('.kiwi-sizing-modal .ks-modal-content-wrapper .ks-table');
  if (modalTable) return modalTable;
  if (!linticoSizeChartContent || !linticoSizeChartContent.isConnected) {
    linticoSizeChartContent = document.querySelector('.kiwi-sizing-modal-hidden-container [id^="ks-chart-content-"]')
      || document.querySelector('.kiwi-sizing-modal [id^="ks-chart-content-"]');
  }
  return linticoSizeChartContent && linticoSizeChartContent.querySelector('.ks-table');
}
function setSizeDetail(size) {
  if (document.querySelector('.quick-buy-modal[open]')) return;
  const target = getSizeSelector();
  const table = getSizeChartTable();
  if (!target || !table) return;
  const rows = Array.from(table.querySelectorAll('.ks-table-row')).map(row =>
    Array.from(row.querySelectorAll('.ks-table-cell')).map(cell => cell.textContent.trim())
  );
  const measurements = readSizeMeasurements(rows, getCurrentSize() || size);
  const root = target.closest('.detail.product-column-right');
  let summary = root.querySelector('#size-detail');
  if (!measurements.length) {
    if (summary) summary.remove();
    return;
  }
  const activeUnit = table.closest('.ks-table-content-wrapper')?.querySelector('.ks-unit-toggle-label.kiwi-active');
  const unit = activeUnit?.textContent.trim().toLowerCase() === 'cm' ? 'cm' : '"';
  const signature = JSON.stringify([measurements, unit]);
  if (summary && summary.dataset.linticoSizeSignature === signature) return;
  if (!summary) {
    summary = document.createElement('div');
    summary.id = 'size-detail';
    summary.className = 'size-detail';
    summary.setAttribute('aria-live', 'polite');
    target.insertAdjacentElement('afterend', summary);
  }
  const fragment = document.createDocumentFragment();
  measurements.forEach(([label, value]) => {
    const item = document.createElement('div');
    item.appendChild(document.createTextNode(label + ': '));
    const measurement = document.createElement('span');
    measurement.textContent = value + unit;
    item.appendChild(measurement);
    fragment.appendChild(item);
  });
  summary.replaceChildren(fragment);
  summary.dataset.linticoSizeSignature = signature;
}
function getCurrentSize() {
  const target = getSizeSelector();
  if (!target) return '';
  const checked = target.querySelector('input.js-option:checked');
  if (checked) return checked.value;
  const active = target.querySelector('li.active, li[aria-current="true"], [aria-selected="true"]');
  if (active) return active.getAttribute('data-value') || active.textContent.trim();
  const select = target.querySelector('select');
  if (select) return select.value;
  try {
    return JSON.parse(document.querySelector('#product-data')?.getAttribute('data-first-variant') || '{}').option2 || '';
  } catch (_) {
    return '';
  }
}
function mountNativeSizeChart() {
  const target = getSizeSelector();
  if (!target || target.hasAttribute('option-target')) return;
  const root = target.closest('.detail.product-column-right');
  if (!root.hasAttribute('data-lintico-native-size-chart')) root.setAttribute('data-lintico-native-size-chart', '');
  const heading = target.querySelector('legend, .label');
  const chart = root.querySelector('.ks-chart-container');
  if (!heading || !chart) return;
  if (!heading.classList.contains('lintico-size-chart-heading')) heading.classList.add('lintico-size-chart-heading');
  if (chart.parentElement !== heading) heading.appendChild(chart);
}
function waitForTableAndInit() {
  const root = document.querySelector('.detail.product-column-right');
  if (!root) return;
  let scheduled = null;
  function refresh() {
    scheduled = null;
    if (document.querySelector('.quick-buy-modal[open]')) return;
    mountNativeSizeChart();
    setSizeDetail(getCurrentSize());
  }
  function schedule() {
    if (scheduled === null) scheduled = window.setTimeout(refresh, 60);
  }
  root.addEventListener('change', schedule);
  root.addEventListener('on:variant:change', schedule);
  const relevant = '.ks-table, .ks-unit-toggle, .ks-chart-container, .kiwi-sizing-modal, .kiwi-sizing-modal-hidden-container, variant-picker, variant-swatch-king';
  new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest(relevant)) return true;
      return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
        (node.matches(relevant) || node.querySelector(relevant)));
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  refresh();
}

function waitForBundlesSave() {
    const swatches = document.querySelector('.detail .swatches-type-products');
    function processBundles() {
      const colorList = document.querySelectorAll('[option-name="Colour"]') || [];
      colorList.forEach(option => {
        const items = option.querySelectorAll('li[orig-value]') || [];
        for (const li of items) {
          const origValue = li.getAttribute('orig-value');
          if (origValue && origValue.includes('/')) {
            if (!li.previousElementSibling?.classList.contains('swatches-bundles-legend')) {
              const legend = document.createElement('p');
              legend.className = 'swatches-bundles-legend';
              legend.textContent = 'Bundles & Save:';
              li.parentNode.insertBefore(legend, li);
            }
            break;
          }
        }
      });
    }

    if (swatches) {
      processBundles();
    } else {
      const targetContainer = document.querySelector('.product-column-right') || document.body;
      const observer = new MutationObserver(() => {
        if (document.querySelector('.detail .swatches-type-products')) {
          processBundles();
          observer.disconnect();
        }
      });
      observer.observe(targetContainer, {
        childList: true,
        subtree: true,
      });
    }
  }

  var ric = window.requestIdleCallback || function (cb) { setTimeout(cb, 200); };
  ric(function () {
    waitForTableAndInit();
    waitForBundlesSave();
  });
});




// 商品列表下拉加载更多
document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.getElementById('product-grid');
  if (!productGrid) return;

  // 获取当前页码和总页数
  let currentPage = parseInt(productGrid.dataset.currentPage) || 1;
  const totalPages = parseInt(productGrid.dataset.totalPages) || 1;

  // 如果只有一页，不需要加载更多功能
  if (totalPages <= 1) {
    const loadingMore = document.querySelector('.loading-more');
    if (loadingMore) {
      loadingMore.style.display = 'none';
    }
    return;
  }

  const loadingMore = document.querySelector('.loading-more');
  let isLoading = false;
  let hasMore = true;

  // 获取下一页URL
  function getNextPageUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('page', currentPage + 1);
    return url.toString();
  }

  // 加载更多商品
  async function loadMoreProducts() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    loadingMore.classList.add('active');

    try {
      const response = await fetch(getNextPageUrl());
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // 获取新的商品元素
      const newGrid = doc.getElementById('product-grid');
      if (newGrid && newGrid.children.length > 0) {
        // 将新商品添加到现有列表中
        Array.from(newGrid.children).forEach(child => {
          productGrid.appendChild(child.cloneNode(true));
        });

        currentPage++;

        // 检查是否还有更多页
        if (currentPage >= totalPages) {
          hasMore = false;
          loadingMore.innerHTML = '<div class="loading-more__text">--end--</div>';
        }
      } else {
        throw new Error('No products found');
      }
    } catch (error) {
      console.error('error:', error);
      hasMore = false; // 加载失败时停止后续加载
      loadingMore.innerHTML = '<div class="loading-more__text">Loading failed, please refresh to try again!</div>';
    } finally {
      isLoading = false;
      if (hasMore) {
        loadingMore.classList.remove('active');
      }
    }
  }

  // 监听滚动事件（passive 保证滚动流畅）
  let scrollTimeout;
  window.addEventListener('scroll', function () {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(function () {
      const productGridRect = productGrid.getBoundingClientRect();
      const scrollPosition = window.innerHeight - productGridRect.bottom;

      // 当商品容器底部距离视窗底部小于300px时触发加载
      if (scrollPosition > -300) {
        loadMoreProducts();
      }
    }, 100);
  }, { passive: true });
});

/* toast */
(function () {
  let container = null;

  function createContainer() {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  function show(message, duration = 3000) {
    if (!container) createContainer();

    if (container.children.length >= 2) {
      container.children[0].remove();
    }

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    container.appendChild(toast);

    void toast.offsetWidth;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.remove();
        if (container && container.children.length === 0) {
          container.remove();
          container = null;
        }
      }, 300);
    }, duration);
  }

  window.toast = show;
})();

// 监听加购商品，检查购物车中是否存在相同商品
(function () {
  // 获取购物车数据
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart data:', error);
      throw error;
    }
  }

  // 加购提示重复加购
  document.addEventListener('on:cart:add', async (event) => {
    if (!event.detail || !event.detail.variantId) return;
    try{
      window.ptengine && window.ptengine.showEngagement('ff7e2b95-f3c8-45b9-8572-9739b769a56a');
      window.ptengine && window.ptengine.showEngagement('70b3984c-3574-4fc1-84af-0fba2d312346');
    }catch (e) {
      console.log(e);
    }
    // 快速加购不提示
    const inQuickBuy = event.target.closest('.quick-buy-modal[open]');
    if (inQuickBuy) return;
    const variantId = parseInt(event.detail.variantId);

    try {
      // 延迟一点获取购物车数据，确保加购操作已完成
      setTimeout(async () => {
        // 获取购物车数据
        const cart = await getCartData();

        // 找到当前添加的商品
        const currentItem = cart.items.find(item => item.variant_id === variantId);

        if (!currentItem) return;

        // 获取表单中的数量输入
        const quantityInput = document.querySelector('form[action="/cart/add"] [name="quantity"]');
        const addedQuantity = quantityInput ? parseInt(quantityInput.value) : 1;

        // 如果购物车中的数量大于刚刚添加的数量，说明之前已经添加过
        if (currentItem.quantity > addedQuantity) {
          toast(`You've selected [${currentItem.product_title}] multiple times. Let’s check your cart together!`);
        }
      }, 100);
    } catch (error) {
      console.error('Error in cart add listener:', error);
    }
  });
})();

// pages/student-teacher-healthcare-worker-discount 样式修改
document.addEventListener("DOMContentLoaded", () => {
  try {
    if (!location.href.includes('student-teacher-healthcare-worker-discount')) return;

    const root = document.querySelector('#beans-id-root');
    const shadow = root?.shadowRoot;

    if (!shadow) return;

    // 插入样式
    const style = document.createElement('style');
    style.textContent = `
      * {
        color: #543c29 !important;
        font-family: Cardo, serif !important;
      }
    `;
    shadow.appendChild(style);

    // 图片资源
    const svgs = [
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-1.png?v=1747471486',
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-2.png?v=1747471486',
      'https://cdn.shopify.com/s/files/1/0686/6793/2851/files/student-3.png?v=1747471486',
    ];

    const handleInsert = () => {
      const pList = shadow.querySelectorAll('p.font-gibson-semibold.text-grey-500');
      pList.forEach((pEl, index) => {
        if (pEl.dataset.modified) return; // 防止重复处理
        pEl.dataset.modified = 'true';

        // 处理文本
        pEl.textContent = pEl.textContent.replace(/^\d+%\s*/, '');

        // 插入图片
        const svgIndex = index % svgs.length;
        const img = document.createElement('img');
        img.src = svgs[svgIndex];
        img.style.width = '36px';
        img.style.height = '36px';

        pEl.style.display = 'flex';
        pEl.style.alignItems = 'center';
        pEl.style.gap = '6px';

        pEl.insertBefore(img, pEl.firstChild);
      });
    };

    // 初始化处理一次
    handleInsert();

    // 设置 observer，监听 shadow DOM 中的变化
    const observer = new MutationObserver(() => {
      handleInsert();

      // 如果所有目标都已处理，断开 observer
      const unprocessed = shadow.querySelector('p.font-gibson-semibold.text-grey-500:not([data-modified])');
      if (!unprocessed) observer.disconnect();
    });

    observer.observe(shadow, { childList: true, subtree: true });

  } catch (e) {
    console.error(e);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  try {
    // 获取 video 元素
    const video = document.querySelector('video.image-adv__media');
    if (video) {
      video.autoplay = true;
      video.play().catch(err => {
        console.log('播放失败:', err);
      });
    }
  } catch (e) {
    console.error(e);
  }

  try {
    const form = document.querySelector('.detail.product-column-right .form.js-product-form');
    const terms = document.querySelector('.detail.product-column-right shopify-payment-terms');

    if (form && terms) {
      form.appendChild(terms.cloneNode(true)); // true 表示深拷贝（包含子节点）
    }

  } catch (e) {
    console.error(e);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/pages/st-patricks-day-2026') {

    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    const ctx = canvas.getContext('2d');
    ctx.font = '24px Arial';
    ctx.fillText('🍀', 0, 24);
    const cursorUrl = canvas.toDataURL();

    document.body.style.cursor = `url(${cursorUrl}) 16 16, auto`;

    const style = document.createElement('style');
    style.innerHTML = `
      * {
        cursor: url(${cursorUrl}) 16 16, auto !important;
      }
    `;
    document.head.appendChild(style);
  }
});

// Collection filter: desktop sidebar + mobile drawer state.
(function initCollectionFilterV2() {
  const desktopMedia = window.matchMedia('(min-width: 1000px)');

  function syncCollectionFilterState() {
    const containers = document.querySelectorAll('.collection-filter-v2');
    let mobileDrawerOpen = false;

    containers.forEach((container) => {
      const isMobileOpen =
        !desktopMedia.matches &&
        container.classList.contains('filter-container--show-filters-mobile');
      const isExpanded = desktopMedia.matches
        ? container.classList.contains('filter-container--show-filters-desktop')
        : isMobileOpen;
      mobileDrawerOpen = mobileDrawerOpen || isMobileOpen;

      const section = container.closest('.shopify-section') || container;
      section.querySelectorAll('[data-toggle-filters]:not(.filter-shade)').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', String(isExpanded));
      });

      const drawer = container.querySelector('.filters');
      if (drawer) {
        if (desktopMedia.matches) {
          drawer.removeAttribute('role');
          drawer.removeAttribute('aria-modal');
          drawer.removeAttribute('aria-hidden');
        } else {
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
          drawer.setAttribute('aria-hidden', String(!isMobileOpen));
        }
      }
    });

    document.documentElement.classList.toggle('collection-filters-open', mobileDrawerOpen);
  }

  function closeMobileCollectionFilters() {
    document.querySelectorAll('.collection-filter-v2.filter-container--show-filters-mobile').forEach((container) => {
      container.classList.remove('filter-container--show-filters-mobile');
      container.classList.add('filter-container--show-filters-desktop');
    });
    syncCollectionFilterState();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-toggle-filters]');
    if (!toggle || !toggle.closest('.shopify-section')?.querySelector('.collection-filter-v2')) return;
    window.requestAnimationFrame(syncCollectionFilterState);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileCollectionFilters();
  });

  document.addEventListener('shopify:section:load', syncCollectionFilterState);
  desktopMedia.addEventListener('change', syncCollectionFilterState);
  syncCollectionFilterState();
})();
